/*
 * ChallengeQuestion Enums
 *
 * Update this file (and remove this line), or delete the file if not needed.
 *
 * Reminder:
 * enum name should use TitleCase and end with 'Enum'
 * enum keys should use TitleCase
 *
 */

export enum ErrorMessageEnum {
  ERROR_EMAIL_EXPIRED = "Email expired.Please contact administrator",
  ERROR_EXCEEDED_ATTEMPTS = "Exceeded the maximum attempts. Account is locked, Please contact administrator.",
  ERROR_EMAIL_MISMATCH = "Email mismatched:",
  ERROR_INVALID_ANSWER = "Challenge question answer not matched.Invalid user",
  ERROR_USER_DOES_NOT_EXIST = "User does not exist:",
  ERROR_REGISTRATION_LINK_EXPIRED = "Registration link expired.Please contact administrator.",
  ERROR_CHALLENGE_QUESTION_NOT_CONFIGURED = "Challenge question not found for partner",
}
